module.exports = __webpack_public_path__ + "img/horizontal_3_4_pp1_3.4c60145d.png";